import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { defaultErrorAction, errorKeyMap } from '@/common/error/error-code'
import { ElMessage } from 'element-plus'
import { i18n } from '@/i18n'

@Injectable()
export class CentralControlService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  updateName (name: string) {
    return this.http.post('/team/update-name', {
      name
    })
  }

  @InvokeThrottle()
  updateUninstallCode (code: string) {
    return this.http.post('/team/update-uninstallcode', {
      code
    }).catch(error => {
      if (error.responseBody?.ret === errorKeyMap.ILLEGAL_PARAMETER.ret) {
        ElMessage.error(i18n.global.t('teamInfoEdit.uninstallPasswordLengthExceeded'))
      } else {
        defaultErrorAction(error)
      }
    })
  }

  @InvokeThrottle()
  updateExitCode (code: string) {
    return this.http.post('/team/update-exitcode', {
      code
    }).catch(error => {
      if (error.responseBody?.ret === errorKeyMap.ILLEGAL_PARAMETER.ret) {
        ElMessage.error(i18n.global.t('teamInfoEdit.exitPasswordLengthExceeded'))
      } else {
        defaultErrorAction(error)
      }
    })
  }
}
